import { useLocation } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'

import SwitchLang from './SwitchLang';
import HomeButton from './HomeButton';
import Menu from './Menu';

import { useShowMenu } from '../contexts/ShowMenuProvider';

export default function Header() {
    const { handleShowMenu } = useShowMenu();

    const menuItems = ['instruction', 'refund', 'offer', 'policy', 'about', 'contacts'];
    const location = useLocation();
    const isStaticPage = menuItems.includes(location.pathname.slice(1));

    return (
        <>
            <Navbar fixed='top' className={isStaticPage ? 'HeaderOpaque' : ''}>
                <Container>
                    {
                        !isStaticPage ? <SwitchLang /> : <HomeButton />
                    }
                    <Button className='MenuButton ms-auto' size='lg' onClick={handleShowMenu}>
                        <FontAwesomeIcon icon={faBars} />
                    </Button>
                </Container>
            </Navbar>

            <Menu menuItems={menuItems} />
        </>
    )
}
